import { render, staticRenderFns } from "./UrlAttributesMassEdit.vue?vue&type=template&id=b833606e&scoped=true&"
import script from "./UrlAttributesMassEdit.vue?vue&type=script&lang=js&"
export * from "./UrlAttributesMassEdit.vue?vue&type=script&lang=js&"
import style0 from "./UrlAttributesMassEdit.vue?vue&type=style&index=0&id=b833606e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b833606e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VCol,VIcon,VRow,VTooltip})
